import { BaseEntity } from 'src/app/tools/models/baseEntity'
import { PriceList } from './price-list-entity';
import { PriceListLineDetail } from './price-list-line-detail-entity';

export class PriceListLine extends BaseEntity {
    priceList               : PriceList;
    priceListLineNumber     : number;
    name                    : string;
    startDate               : Date
    endDate                 : Date
    closed                  : boolean;
    priceListLineDetails    : PriceListLineDetail[] = [];
}